import React from 'react';
import { useTranslation } from 'react-i18next';

import { formatChatAuthor } from './chatUiPolicy';

/** 서버가 확인한 작성자 이름과 현재 직급을 접근 가능한 한 줄로 표시합니다. */
export default function ChatAuthorLabel({ name, position, style }) {
  const { t } = useTranslation();
  const author = formatChatAuthor(name, position, t('직급'));
  if (!author.visual) return null;

  return (
    <span style={style} aria-label={author.accessible}>
      {author.visual}
    </span>
  );
}
